import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconRequireAttention = ({ color = 'var(--color-accent-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
            <circle opacity="0.2" cx="18.5" cy="18.5" r="18.5" fill={color} />
            <g clipPath="url(#clip0)">
                <path fillRule="evenodd" clipRule="evenodd" d="M17.4183 11.6158C17.8875 10.7817 19.1125 10.8078 19.5817 11.6158L25.8371 22.4847C26.3063 23.3187 25.7068 24.3352 24.7424 24.3352H12.2576C11.2932 24.3352 10.6937 23.2927 11.1629 22.4847L17.4183 11.6158ZM17.6632 19.6152L17.4807 16.696C17.4807 16.5135 17.611 16.3572 17.7935 16.3572H19.227C19.4095 16.3572 19.5398 16.5135 19.5398 16.696L19.4486 18.1556L19.3573 19.6152C19.3573 19.7716 19.227 19.9019 19.0446 19.9019H17.9759C17.7935 19.9019 17.6632 19.7977 17.6632 19.6152ZM18.5233 20.2668C19.1228 20.2668 19.618 20.762 19.618 21.3615C19.618 21.9871 19.1228 22.4562 18.5233 22.4562C17.8977 22.4562 17.4286 21.9871 17.4286 21.3615C17.4286 20.762 17.8977 20.2668 18.5233 20.2668Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="15" height="15" fill="white" transform="translate(11 10)" />
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconRequireAttention;
